export interface Purchase {
  name: string
  location: string
}

export const purchases: Purchase[] = [
  { name: 'Emily R.', location: 'Manchester, United Kingdom' },
  { name: 'Jessica M.', location: 'Toronto, Canada' },
  { name: 'Ashley T.', location: 'Dallas, Texas, United States' },
  { name: 'Chloe W.', location: 'Melbourne, Australia' },
  { name: 'Sarah L.', location: 'Birmingham, United Kingdom' },
  { name: 'Nicole B.', location: 'Vancouver, Canada' },
  { name: 'Megan P.', location: 'Orlando, Florida, United States' },
  { name: 'Olivia K.', location: 'Sydney, Australia' },
  { name: 'Rachel D.', location: 'Glasgow, United Kingdom' },
  { name: 'Amanda S.', location: 'Calgary, Canada' },
  { name: 'Brittany H.', location: 'Columbus, Ohio, United States' },
  { name: 'Hannah G.', location: 'Perth, Australia' },
  { name: 'Laura F.', location: 'Bristol, United Kingdom' },
  { name: 'Kayla J.', location: 'Ottawa, Canada' },
  { name: 'Danielle C.', location: 'Charlotte, North Carolina, United States' },
  { name: 'Sophie A.', location: 'Adelaide, Australia' },
]
